export function setIngredients(ingredients: any) {
  storeInLocalStorage('foodList', ingredients);
}

export function getIngredients(ingredients: any) {
  storeInLocalStorage('foodList', ingredients);
}

export function storeInLocalStorage(key: string, value: any) {
  localStorage.setItem(key, JSON.stringify(value));
}
export function updateLocalStorageList(key: string, data: any) {
  const localData = localStorage.getItem(key);

  if (localData) {
    const parsedData = JSON.parse(localData);
    parsedData.push(data);
    storeInLocalStorage(key, parsedData);
  } else {
    storeInLocalStorage(key, [data]);
  }
}

export function retrieveFromLocalStorage(key: string) {
  const data = localStorage.getItem(key);
  return data ? JSON.parse(data) : null;
}
